import { gql } from "@apollo/client";

export const GET_HEADER_CARD_DATA = gql`
  query GetHeaderCardData {
    getHeaderCardData {
      totalStudent
      totalTeacher
      totalClass
      totalOwe
      totalRevenue
    }
  }
`;

export const GET_TOTAL_REVENUE_BY_YEAR = gql`
  query Query($year: String) {
    getTotalRevenueByYear(year: $year)
  }
`;

export const GET_ATTENDANCE_BY_TYPE = gql`
  query GetAttendanceByType($fitlerType: String) {
    getAttendanceByType(fitlerType: $fitlerType) {
      name
      totalPresent
      totalLate
      totalPermission
      totalAbsent
    }
  }
`;

export const GET_STUDENT_DROP_OUT_BY_TYPE = gql`
  query GetTotalStudentDroupout($filterType: String, $date: String) {
    getTotalStudentDroupout(filterType: $filterType, date: $date) {
      name
      total
    }
  }
`;

export const GET_TOTAL_STUDENT_BY_GENDER = gql`
  query GetTotalStudentByGender {
    getTotalStudentByGender {
      totalStudent
      totalFemale
      totalMale
    }
  }
`;

export const GET_STUDENT_BY_ENROLLMENT_STATUS = gql`
  query GetStudentByEnrollmentStatus(
    $page: Int
    $limit: Int
    $status: String
    $payAs: String
  ) {
    getStudentByEnrollmentStatus(
      page: $page
      limit: $limit
      status: $status
      payAs: $payAs
    ) {
      students {
        updatedAt
        completedDate
        studentId {
          _id
          familyName
          studentName
          profile
          gender
        }
        classId {
          _id
          className
          courseId {
            _id
            enName
            khName
          }
        }
      }
      totalCount
    }
  }
`;

export const GET_TOTAL_REVENUE_BY_TYPE = gql`
  query GetTotalRevenueByType($filterMonth: String) {
    getTotalRevenueByType(filterMonth: $filterMonth) {
      totalPiano
      totalGuitar
      totalDrum
      totalByOnlineClass
      totalByBook
      totalByInstrument
      totalAmount
    }
  }
`;

export const GET_SCHEDULE_FOR_DASHBOARD = gql`
  query GetScheduleForDashboard(
    $day: String
    $courseId: ID
    $page: Int
    $limit: Int
  ) {
    getScheduleForDashboard(
      day: $day
      courseId: $courseId
      page: $page
      limit: $limit
    ) {
      classData {
        classId {
          _id
          className
          courseId {
            _id
            enName
            khName
          }
        }
        teacherId {
          _id
          familyName
          userName
        }
        times {
          startTime
          endTime
          totalStudying
          totalComplete
        }
      }
      totalCount
    }
  }
`;

export const AUTO_CHECK_COMPLETE_CLASS_AS_MONTH = gql`
  mutation Mutation {
    autoCheckCompleteClass {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_TOTAL_REVENUE_BY_FILTER_DASHBOARD = gql`
  query GetTotalRevenueByFilter($filterType: String, $date: String) {
    getTotalRevenueByFilter(filterType: $filterType, date: $date) {
      name
      total
    }
  }
`;

export const GET_TEACHER_BIRTHDAY = gql`
  query GetTeacherBirthdayForDashboard {
    getTeacherBirthdayForDashboard {
      _id
      profile
      teacherId
      familyName
      userName
      gender
      dob
    }
  }
`;
